import { memo as Memo } from 'react';

//* Components
import Icon from 'components/common/Icon';
import Text from 'components/common/Text';
import Image from 'components/common/Image';

//* Style
import TestimonialSectionStyle from './style';

const TestimonialSection = Memo(({ className, text, image, author, position }) => {
	return (
		<TestimonialSectionStyle className={`${className || ''}`}>
			<div className={`testimonialIntWrap`}>
				<div className={`testimonialTextWrap`}>
					<div className={`addWrapper`}>
						<Icon className={`bb-quote left`} />
						<Text
							className={`h4 maisonNeueBook blackRussian`}
							text={text}
						/>
						<Icon className={`bb-quote right`} />
					</div>
				</div>
				<div className={`testimonialLogoWrap`}>
					<Image
						priority
						objectFit={`contain`}
						src={image.url}
						alt={image.alt}
					/>
				</div>
				<Text
					className={`h6 maisonNeueMedium blackRussian author`}
					text={author}
				/>
				<Text
					className={`pS maisonNeueBook blackRussian position`}
					text={position}
				/>
			</div>
		</TestimonialSectionStyle>
	);
});

export default TestimonialSection;
